import { forwardRef, createElement } from 'react';
import cn from 'classnames';

const Field = /*#__PURE__*/forwardRef(function Field(props, ref) {
  const {
    disabled,
    children,
    invalid = false,
    message,
    ...otherProps
  } = props;
  const className = cn('flex flex-col font-bold text-xs leading-loose pb-4 min-h-[theme(spacing.18)]', {
    'text-grey-dark': disabled
  }, props.className);
  const messageClassName = cn('h-4 text-xs text-left leading-normal font-normal truncate -mb-4', {
    'text-grey-darkest': !invalid,
    'text-red': invalid,
    'opacity-50': disabled
  }, props.className);
  return createElement("label", Object.assign({}, otherProps, {
    className: className,
    "data-taco": "label",
    ref: ref
  }), children, message && createElement("span", {
    className: messageClassName,
    role: invalid ? 'alert' : undefined
  }, message));
});

export { Field };
//# sourceMappingURL=Field.js.map
